import styled from "styled-components";
import { EditIcon } from "../../../../Previews/Svg";
import { TIKTOK_IMAGE_SIZE_SPEC } from "./PrintVideoPostEditorTikTok.constants";

export const PostEditorTikTokWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${TIKTOK_IMAGE_SIZE_SPEC.width}px;
`;

export const HeaderWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  padding-top: 10px;
  color: white;
  width: 100%;
`;
export const MobileHead = styled.div`
  font-size: 13px;
  text-align: left;
  padding-left: 20px;
`;
export const HeaderMenu = styled.div`
  text-align: center;
  margin-top: 20px;
  opacity: 0.8;
`;
export const SelectedMenuItem = styled.span`
  font-weight: 600;
  opacity: 1;
`;
export const EditorWrapper = styled.div`
  position: absolute;
  bottom: 0;
  margin-bottom: 10px;
  color: white;
  left: 0;
  text-align: left;
  max-width: 80%;
`;
export const FooterWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px 25px;
  color: white;
  background-color: black;
  height: 80px;
  border-radius: 0 0 10px 10px;
`;
export const WhiteLine = styled.div`
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 3px;
  border-radius: 10px;
  background-color: white;
`;
export const MenuItem = styled.div`
  font-size: 10px;
  text-align: center;
  svg {
    width: 30px;
    height: 30px;
  }
`;
export const RightMenu = styled.div`
  position: absolute;
  bottom: 80px;
  margin-bottom: 10px;
  margin-right: 5px;
  color: white;
  right: 0;
  ${MenuItem} {
    font-size: 12px;
    svg {
      width: 40px !important;
      height: 40px !important;
    }
  }
  & > div {
    margin-bottom: 14px;
  }
  transition: all 0.2s ease;
  opacity: 0;
`;

export const PhotoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: ${TIKTOK_IMAGE_SIZE_SPEC.maxHeight}px;
  &:hover {
    ${RightMenu} {
      opacity: 1;
    }
  }
`;

export const TikTokWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${TIKTOK_IMAGE_SIZE_SPEC.width}px;
  height: ${TIKTOK_IMAGE_SIZE_SPEC.height}px;
  box-shadow: 0px 2px 4px 0px #1516331f;
  background: #19191b;
  border-radius: 10px;
`;

export const PromotionalText = styled.div`
  padding-left: 10px;
  svg {
    width: 10px;
    height: 10px;
  }
`;
export const CompanyName = styled.div`
  display: flex;
  align-items: baseline;
  padding-left: 10px;
`;
export const Add = styled.div`
  color: black;
  background-color: white;
  border-radius: 6px;
  padding: 6px 10px;
  margin-bottom: 6px;
  margin-right: 10px;
`;

export const Edit = styled(EditIcon)`
  height: 30px;
  color: white;
  cursor: pointer;
  margin-bottom: 10px;
`;
